const ARTICLES = new Set(['der', 'die', 'das']);
/** An article already at the start of an IPA string ("deːɐ̯ ", "diː ", "das ", also loose variants). */
const LEADING_ARTICLE = /^(?:deːɐ̯|deːɐ|deːr|dɛɐ̯|diː|di|die|das)\s+/u;
/** Removes a leading article from an IPA string: "/diː ˈʃɪfə/" -> "/ˈʃɪfə/". */
export function stripArticleIpa(ipa) {
    if (!ipa)
        return ipa;
    const slashed = ipa.trim().startsWith('/');
    const core = ipa
        .trim()
        .replace(/^\/|\/$/g, '')
        .trim()
        .replace(LEADING_ARTICLE, '');
    return slashed ? `/${core}/` : core;
}
/** A pronunciation as shown on a card: as stored, without an article (one stored by mistake is dropped). */
export function displayIpa(ipa) {
    return ipa ? (stripArticleIpa(ipa) ?? undefined) : undefined;
}
/** The article at the start of a written form ("die Tische" -> "die"), if any. */
export function leadingArticle(text) {
    const match = text?.trim().match(/^(der|die|das)\s/i);
    return match ? match[1].toLowerCase() : undefined;
}
/** What the speaker button reads for a word: nouns with their article ("das Schiff"). */
export function spokenForm(word, article) {
    const text = word.trim();
    const art = article?.trim().toLowerCase();
    if (!art || !ARTICLES.has(art) || text.toLowerCase().startsWith(`${art} `))
        return text;
    return `${art} ${text}`;
}
